// extracted by mini-css-extract-plugin
module.exports = {"row":"VirtualTableRow-row-2-JS9"};